// src/v3/ui/table-presets/backtester-presets.ts

import type { SmartTablePreset } from "../_common";

export const backtesterPresets: SmartTablePreset[] = [
  {
    id: "default",
    name: "Default",
    columns: [
      "strategy",
      "summary.netProfit",
      "summary.totalTrades",
      "summary.winRate",
      "summary.sharpe",
      "summary.maxDrawdown",
      "summary.profitFactor",
    ],
    filters: [],
    sort: [],
    pageSize: 50,
  },
];
